import firebase from 'firebase';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyBelwO8P70VExe4REI89oxGvMvQsbNna4c',
  authDomain: 'fir-vue-de1f1.firebaseapp.com',
  databaseURL: 'https://fir-vue-de1f1.firebaseio.com',
  projectId: 'fir-vue-de1f1',
  storageBucket: 'fir-vue-de1f1.appspot.com',
  messagingSenderId: '1024308798435'
};
firebase.initializeApp(config);

// export default {
//   database: firebase.database()
// };
export const firebaseAuth = firebase.auth();
export const firebasedb = firebase.database();
export const firestoredb = firebase.firestore();
export const firebaseStorage = firebase.storage();
// export const mailsRef = db.ref('mails');



// WEBPACK FOOTER //
// ./src/firebase.js